import $ from 'jquery';
import { BREAKPOINTS } from "./breakpoints";
import debounce from 'lodash.debounce';

export default class WindowUtil {
    constructor() {
        this.$window = $(window);
        this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
        this.windowHeight = window.innerHeight;
        this.scrollCount = null;
        this.startScrollPos = 0;

        this.maxEmXsmall = this.convertPxToEm(BREAKPOINTS.small.px - 1);
        this.maxEmSmall = this.convertPxToEm(BREAKPOINTS.medium.px - 1);
        this.maxEmMedium = this.convertPxToEm(BREAKPOINTS.large.px - 1);
        this.maxEmLarge = this.convertPxToEm(BREAKPOINTS.xlarge.px - 1);
        // ビューポートをターゲットとするMediaListを作成
        this.matchMediaQueryXsmall = window.matchMedia(`(min-width: 1px) and (max-width: ${this.maxEmXsmall}em)`);
        this.matchMediaQuerySmall = window.matchMedia(`(min-width: ${BREAKPOINTS.small.em}em) and (max-width: ${this.maxEmSmall}em)`);
        this.matchMediaQueryMedium = window.matchMedia(`(min-width: ${BREAKPOINTS.medium.em}em) and (max-width: ${this.maxEmMedium}em)`);
        this.matchMediaQueryLarge = window.matchMedia(`(min-width: ${BREAKPOINTS.large.em}em) and (max-width: ${this.maxEmLarge}em)`);
        this.matchMediaQueryXlarge = window.matchMedia(`(min-width: ${BREAKPOINTS.xlarge.em}em)`);

        this.$window.on('resize', debounce(() => {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        }, 500));

        // このあたりはScrollOutでカバーできそう↓
        this.$window.on('scroll', debounce(() => {
            this.scrollCount = this.$window.scrollTop();
            if (this.scrollCount > this.startScrollPos) {
                //下方向のスクロール時
                // something
            } else {
                //上方向のスクロール時
                // something
            }
            this.startScrollPos = this.$window.scrollTop();
        }, 200));
    }

    convertPxToEm(pxValue) {
        return +pxValue / 16;
    };
};
